import { render, staticRenderFns } from "./StorageDashboard.vue?vue&type=template&id=7a6c765e&"
import script from "./StorageDashboard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StorageDashboard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports